import React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SiteLink } from "./links";

interface Props {
  link: SiteLink;
}

/**
 * SiteLink を MUI の Link として描画する。
 * アプリ内リンクとして描くか外部リンクとして描くかの分岐はここだけに置く。
 */
const SiteLinkItem = ({ link }: Props) => {
  if (link.to !== undefined) {
    return (
      <Link
        color="inherit"
        underline="hover"
        component={RouterLink}
        to={link.to}
      >
        {link.label}
      </Link>
    );
  }

  return (
    <Link
      color="inherit"
      underline="hover"
      href={link.href}
      target="_blank"
      rel="noreferrer"
    >
      {link.label}
    </Link>
  );
};

export default SiteLinkItem;
